'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var i18n;

module.exports = i18n = function () {
  var DEFAULT_LANG;

  var i18n = function () {
    function i18n() {
      _classCallCheck(this, i18n);

      this.localise = this.localise.bind(this);
      this._entities = {};
      this._defaultLang = DEFAULT_LANG;
      this._language = this._defaultLang;
      this.i18n = riot.observable();
      this.i18n.on('lang', this.setLanguage);
      this.i18n.localise = this.localise;
      this.i18n.addLanguage = this.addLanguage;
      this.i18n.setLanguage = this.setLanguage;
    }

    _createClass(i18n, [{
      key: 'localise',
      value: function localise(key) {
        var ref;
        if (!((ref = this._entities[this._language]) != null ? ref[key] : void 0)) {
          return key;
        }
        return this._entities[this._language][key];
      }
    }, {
      key: 'setLanguage',
      value: function setLanguage(lang) {
        this._language = lang || this._defaultLang;
        return this.i18n.trigger('update');
      }
    }, {
      key: 'addLanguage',
      value: function addLanguage(code, lang) {
        return this._entities[code] = lang;
      }
    }]);

    return i18n;
  }();

  ;

  DEFAULT_LANG = 'en';

  return i18n;
}.call(undefined);